import ProvidersList from './ProvidersList';

export default ProvidersList;
